<script lang="ts">
  import {tooltip} from '@/actions/tippy-action';
  import LayerPanel from '@/pages/thumbPreview/Layer/LayerPanel.svelte';
  import {onDestroy, onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import Component from '../../Component/Component';
  import editorStore from '../../editor.store';
  import type {EditorActiveComponent} from '../../types';

  let show = writable(false);
  let button: HTMLElement;
  let item: EditorActiveComponent;
  const unmount = editorStore.subscribe(store => {
    store.components;
    if (store.activeComponent == item) return;
    show.set(false);
    item = store.activeComponent;
  });

  // console.log("edtorstore",$editorStore.components, $editorStore)

  // const showFn = () => {
  //   show.update((s) => {
  // 	s = !s;
  // 	return s;
  //   });
  // };

  // const layerUp = () => {
  //   if (!item) return;
  //   adjustZIndex(item as HTMLElement, 1);
  // };

  // const layerDown = () => {
  //   if (!item) return;
  //   adjustZIndex(item as HTMLElement, -1);
  // };

  let stampElements = [];
  let zIndexes: any = [];

  function openLayerPanel() {
    if (
      $editorStore.activeComponent?.getAttribute('data-amelement') === 'quote' ||
      $editorStore.activeComponent?.getAttribute('data-amelement') === 'title'
    )
      editorStore.setActiveComponent(null);
    editorStore.setPopoverComponent(LayerPanel, 'Layer');
  }

  // Function to move element up in z-index order
  function moveUp() {
    let index = zIndexes.findIndex((z: any) => item === z.element);
    if (index < zIndexes.length - 1) {
      // Swap z-index with the next element
      let temp = zIndexes[index].zIndex;
      zIndexes[index].zIndex = zIndexes[index + 1].zIndex;
      zIndexes[index + 1].zIndex = temp;

      zIndexes.sort((a: any, b: any) => a.zIndex - b.zIndex);
      // Update the elements' styles
      updateZIndexes();
    }
  }

  // Function to move element down in z-index order
  function moveDown() {
    let index = zIndexes.findIndex((z: any) => item === z.element);
    if (index > 0) {
      // Swap z-index with the previous element
      let temp = zIndexes[index].zIndex;
      zIndexes[index].zIndex = zIndexes[index - 1].zIndex;
      zIndexes[index - 1].zIndex = temp;

      zIndexes.sort((a: any, b: any) => a.zIndex - b.zIndex);
      // Update the elements' styles
      updateZIndexes();
    }
  }

  // Apply the updated z-indexes to the DOM elements
  function updateZIndexes() {
    zIndexes.forEach((item: any, index: number) => {
      if (item && item.element) item.element.style.zIndex = item.zIndex;
    });
  }

  const unsub = editorStore.subscribe(store => {
    zIndexes = store.components.map((el: Component, index: number) => {
      return {
        element: el.element,
        type: el.type,
        index: index,
        zIndex: parseInt(getComputedStyle(el.element).zIndex, 10) || index + 1
      };
    });

    // Sort by z-index in ascending order
    zIndexes.sort((a: any, b: any) => a.zIndex - b.zIndex);
    updateZIndexes();
  });

  // Initialize on component mount
  onMount(() => {
    // initializeToolbar();
    zIndexes = $editorStore.components.map((el: Component, index: number) => {
      return {
        element: el.element,
        type: el.type,
        index: index,
        zIndex: parseInt(getComputedStyle(el.element).zIndex, 10) || index + 1
      };
    });
    // Sort by z-index in ascending order
    zIndexes.sort((a: any, b: any) => a.zIndex - b.zIndex);
    for (let i = 1; i < zIndexes.length; i++) {
      if (zIndexes[i].zIndex === zIndexes[i - 1].zIndex) {
        zIndexes[i].zIndex = zIndexes[i - 1].zIndex + 1;
      }
    }
    updateZIndexes();
  });

  onDestroy(() => {
    unsub();
  });
</script>

<div class="flex items-center justify-center">
  <button class="btn centerItem rounded-md px-2" use:tooltip={'Move one layer up'} on:click={() => moveUp()}>
    <i class="fa fa-caret-up" />
  </button>
  <button class="btn centerItem rounded-md px-2" use:tooltip={'Move one layer down'} on:click={() => moveDown()}>
    <i class="fa fa-caret-down" />
  </button>
  <button class="btn centerItem rounded-lg border border-gray-300 px-4 font-bold" on:click={() => openLayerPanel()}>
    Layer
  </button>
</div>

<style lang="postcss">
  .btn {
    @apply mx-1 flex h-full cursor-pointer items-center justify-center text-center hover:bg-gray-100;
  }
  .btn.active {
    @apply bg-gray-300 hover:bg-gray-100;
  }
</style>
